<template>
  <div class="home">
    <bar-top></bar-top>
    <alert-handler ref="alert"/>
    {{serverVersion}}
    <b-card no-block v-if="Object.keys(this.config).length">
      <b-tabs small card ref="tabs" v-model="tabIndex">
        <b-tab title="Templates">
            <b-card no-block v-for="(templ, index) in this.config.templates" class="template-card" :key="templ.id" :header="templ.displayname" header-variant="template-header">
                <div class="dlbuttons">
                  <b-button variant="default" @click="downloadTemplate(templ)"><i class="fa fa-download"></i> Download</b-button>
                  <b-button variant="default" @click="uploadTemplate(templ, index)" :disabled="!files[index]"><i class="fa fa-upload"></i> Upload</b-button>
                  <b-form-file ref="fileinput" v-model="files[index]" placeholder=" "></b-form-file>
                </div>
            </b-card>
        </b-tab>
        <b-tab title="Email" v-if="privDeveloper">
          <b-form ref="formEmail" autocomplete="off">
            <div>
              <detail-field label="SMTP Port" field="smtp_port" :rec="this.config.email_config" :isReadOnly="!editEmail" vvalidate="required" :validator="email_validator"/>
              <detail-field label="SMTP Server" field="smtp_servername" :rec="this.config.email_config" :isReadOnly="!editEmail" vvalidate="required" :validator="email_validator"/>
              <detail-field label="SMTP Username" field="smtp_username" :rec="this.config.email_config" :isReadOnly="!editEmail" vvalidate="ok" :validator="email_validator"/>
              <detail-field label="SMTP Password" field="smtp_password" :rec="this.config.email_config" type="password" :isReadOnly="!editEmail" vvalidate="ok" :validator="email_validator"/>
              <detail-field label="Test Email" field="test_email_address" :rec="this.config.email_config" :isReadOnly="!editEmail" vvalidate="email" :validator="email_validator"/>
              <detail-field label="From: Email" field="from_email_address" :rec="this.config.email_config" :isReadOnly="!editEmail" vvalidate="required|email" :validator="email_validator"/>
            </div>
          </b-form>
          <b-button v-if="!editEmail" variant="default" @click="editEmail = !editEmail"><i class="fa fa-pencil"></i> Edit</b-button>
          <b-button v-if="editEmail" variant="default" @click="saveEmail()"><i class="fa fa-save"></i> Save</b-button>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import api from '../api'
import Validation from '../validation'
import barTop from '../components/BarTop.vue'
import alertHandler from '../components/AlertHandler.vue'
import DetailField from '../components/DetailField'
import PrivilegeMixin from '../components/PrivilegeMixin'
export default {
  name: 'home',
  components: { barTop, alertHandler, DetailField },
  mixins: [PrivilegeMixin],
  data () {
    return {
      email_validator: Validation.createValidator(),
      config: {},
      editEmail: false,
      files: {},
      tabIndex: 0,
      serverVersion: ''
    }
  },
  mounted () {
    this.getConfig()
    this.getVersion()
  },
  methods: {
    getConfig () {
      api.get('/config', null, data => {
        this.config = data
        Validation.setOriginalRec(this.email_validator, data.email_config)
      }, 'getting configuration', this.$refs.alert)
    },
    getVersion () {
      api.get('/config/version', null, data => { this.serverVersion = data.version }, 'getting configuration', this.$refs.alert)
    },
    downloadTemplate (templ, index) {
      console.log('download()', templ)
      api.downloadPost('/config/get_template', templ, templ.filename)
    },
    uploadTemplate (templ, index) {
      console.log(this.$refs.fileinput[index])
      api.uploadPost(api.queryStringify('/config/import/', {internalname: templ.internalname}), [this.files[index]], () => {
        this.$refs.fileinput[index].reset()
      })
      // this.$refs.fileinput[index].state = 'success'
    },
    saveEmail () {
      Validation.validateAll(this.email_validator, this.config.email_config, rec => {
        api.putUpdate('/config/email/', rec, () => { this.editEmail = false }, 'saving configuration', this.$refs.alert)
        this.getConfig()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.template-header {
  font-weight: bold;
}
.dlbuttons {
  margin: 5px auto;
}
.template-card {
  margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// Config.vue?bfc9368e